import { ParsedUrlQuery } from 'querystring';

export const resetPagination = (routerQuery: Record<string, ParsedUrlQuery[0]>) => {
	delete routerQuery['page'];
};
